import Client from './client';

export default class ShopifyGrantsChecks extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getCheckhtml(options = {}) {
    return this.makeRequest(`${this.host}/shopify/grants/check.html`, options);
  }

}
